import type { Curve, Object3D, SceneControl } from '@anov/3d-core'
import { CurvePath, LineCurve3, Vector3, utils } from '@anov/3d-core'

type Option = Partial<{
  speed: number
  duration: number
  paused: boolean
  repeat: number
  yoyo: boolean
  ease: string
}>

type Points = [number, number, number]

type Path = Points[] | Curve<Vector3>

/**
 * 默认参数值
 * speed: 运行速度
 * duration: 运行总时长，当存在总时长时，优先总时长，忽略speed值
 */
const defaultOption: Option = {
  speed: 2,
  duration: null,
  paused: false,
  repeat: -1,
  yoyo: false,
  ease: 'power1.out',
}

class AnimationMotion {
  moveManage: any
  private sceneControl: SceneControl

  constructor(object: Object3D, path: Path, option: Option = {}, sceneControl: SceneControl) {
    this.sceneControl = sceneControl
    let curvePath
    if (Array.isArray(path))
      curvePath = this.getPath(path as Points[])
    else
      curvePath = path as Curve<Vector3>

    this.moveManage = utils.moveWithLine(object, curvePath, { ...defaultOption, ...option, sceneControl })
  }

  getPath(points: Points[] = []) {
    const curvePath = new CurvePath<Vector3>()
    if (points.length < 2) {
      // 如果点数少于两个，返回空的 CurvePath
      return curvePath
    }

    points.forEach((point, index) => {
      const nextIndex = (index + 1) % points.length
      const startPoint = new Vector3().fromArray(point)
      const endPoint = new Vector3().fromArray(points[nextIndex])
      const line = new LineCurve3(startPoint, endPoint)
      curvePath.add(line)
    })
    return curvePath
  }

  setSpeed(speed: Number) {
    this.moveManage.setSpeed(speed)
  }

  play() {
    this.moveManage.continue()
  }

  pause() {
    this.moveManage.stop()
  }

  restart() {
    this.moveManage.restart()
  }

  delete() {
    this.moveManage.remove()
  }
}

export default AnimationMotion